import React from "react";
import { Hammer, Wrench, Sparkles, FileText, CheckCircle2, Award } from "lucide-react";

export const PILL_ICONS = [Hammer, Wrench, Sparkles, FileText, CheckCircle2, Award].map((I, k) => <I key={k} className="h-4 w-4" />);

const BRAND_LOGO = "/brand/sadicasa-light-crop.png";
const logoSrc = (logo) => (!logo || logo.endsWith("/brand/sadicasa-light.png") ? BRAND_LOGO : logo);

function DatiDestra({ azienda: a, L }) {
  return (
    <div className="text-right text-xs text-zinc-600 leading-relaxed" data-testid="prev-stampa-azienda-dati">
      {L.mostra_indirizzo && a.indirizzo && <div data-testid="prev-stampa-sede">{a.indirizzo}</div>}
      {L.mostra_telefono && a.telefono && <div>Tel: {a.telefono}</div>}
      {L.mostra_email && a.email && <div>{a.email}</div>}
      {L.mostra_pec && a.pec && <div className="mono">PEC: {a.pec}</div>}
      {L.mostra_piva && a.piva && <div className="mono mt-1" data-testid="prev-stampa-piva">P.IVA {a.piva}</div>}
      {L.mostra_cf && a.codice_fiscale && a.codice_fiscale !== a.piva && <div className="mono" data-testid="prev-stampa-cf">C.F. {a.codice_fiscale}</div>}
      {L.mostra_rea && a.rea && <div className="mono">REA: {a.rea}</div>}
    </div>
  );
}

export function HeaderAzienda({ azienda: a, L, colorePrimario }) {
  const sedi = L.mostra_sedi && Array.isArray(a.sedi_operative) ? a.sedi_operative : [];
  return (
    <div className="px-12 pt-5 pb-3 border-b-4" style={{ borderColor: colorePrimario }} data-testid="prev-stampa-header">
      <div className="flex items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <img src={logoSrc(a.logo)} alt="Logo" style={{ height: `${Number(L.logo_altezza) || 96}px`, width: "auto" }} data-testid="prev-stampa-logo"
            onError={(e) => { if (!e.currentTarget.src.endsWith(BRAND_LOGO)) e.currentTarget.src = BRAND_LOGO; }} />
          {((L.mostra_ragione_sociale_logo && a.ragione_sociale) || (L.mostra_sito && a.sito)) && (
            <div>
              {L.mostra_ragione_sociale_logo && a.ragione_sociale && <div className="text-[11px] text-zinc-600" data-testid="prev-stampa-ragione-sociale">{a.ragione_sociale}</div>}
              {L.mostra_sito && a.sito && <div className="text-xs text-zinc-500 mono">{a.sito}</div>}
            </div>
          )}
        </div>
        <DatiDestra azienda={a} L={L} />
      </div>
      {sedi.length > 0 && (
        <div className="mt-2 pt-2 border-t border-zinc-200 flex flex-wrap gap-x-6 gap-y-1 text-[10px] text-zinc-500" data-testid="prev-stampa-sedi-operative">
          <span className="uppercase tracking-widest font-semibold">Sedi operative:</span>
          {sedi.map((s, i) => (
            <span key={s.id || i} data-testid={`prev-stampa-sede-op-${i}`}>
              <strong className="text-zinc-700">{s.nome}</strong>{s.indirizzo ? ` — ${s.indirizzo}` : ""}{s.citta ? `, ${s.citta}` : ""}{s.cap ? ` ${s.cap}` : ""}{s.telefono ? ` · tel ${s.telefono}` : ""}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
